import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { EqualHeightElement } from "../EqualHeight/EqualHeightElement";
import { Price } from "../Price";

import styles from "./ProductTile.scss";

const ProductTilePrice = forwardRef(
  (
    { prefix, value, suffix, variants, placeholder, customClass, ...restProps },
    ref
  ) => {
    return (
      <EqualHeightElement
        name={
          variants === "secondary"
            ? "ProductTilePriceSecondary"
            : "ProductTilePricePrimary"
        }
        placeholder={placeholder}
        className={cx(styles.priceWrapper, {
          [styles.priceWrapperPrimary]: variants === "primary",
          [styles.priceWrapperSecondary]: variants === "secondary",
        })}
      >
        <div ref={ref} className={cx(customClass)} {...restProps}>
          <Price
            prefix={prefix}
            value={value}
            suffix={suffix}
            variants={[
              variants === "default" || variants === "primary"
                ? Price.Variant.brand
                : Price.Variant.currentColor,
              Price.Variant.highlight,
              Price.Variant.large,
            ]}
          />
        </div>
      </EqualHeightElement>
    );
  }
);

ProductTilePrice.displayName = "ProductTile.Price";

ProductTilePrice.propTypes = {
  prefix: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  suffix: PropTypes.string,
  variants: PropTypes.oneOf(["default", "primary", "secondary"]),
  placeholder: EqualHeightElement.propTypes.placeholder,
  customClass: PropTypes.string,
};

ProductTilePrice.defaultProps = {
  prefix: undefined,
  suffix: undefined,
  variants: "default",
  placeholder: EqualHeightElement.defaultProps.placeholder,
  customClass: undefined,
};

export default ProductTilePrice;
